<div class="asset-section">
	<div class="section-title">Rotor Track + Balance</div>

	@if (!rotors) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading rotors...
	</div>
	}

	@if (rotors && !rotors.length) {
	<div class="loading-status">
		No rotors found for this asset
	</div>
	}

	@if (rotors && rotors.length) {
	<div>
		<div class="row">
			<label class="col-md-2 col-form-label">Rotor:</label>
			<div class="col-md-4">
				<select class="form-control" [ngModel]="selectedRotor" (ngModelChange)="rotorChange($event)">
					@for (rotor of rotors; track rotor) {
					<option [ngValue]="rotor">{{rotor.name}}</option>
					}
				</select>
			</div>
		</div>
		@if (selectedRotor) {
		<div>
			<div class="bubble-tabs">
				<a class="bubble-tab" routerLink="rotor-vibe" routerLinkActive="selected" preventNavIfSelected>Rotor Vibration</a>
				<a class="bubble-tab" routerLink="rotor-track" routerLinkActive="selected">Rotor Track</a>
				@if (vibecheck) {
				<a class="bubble-tab" routerLink="vibe-check" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(vibecheckstatus)">Vibration Checks</a>
				}
				@if (absCheck) {
				<a class="bubble-tab" routerLink="abs-check" routerLinkActive="selected">Absorber Tuning</a>
				}
				<a class="bubble-tab" routerLink="vibe-history" routerLinkActive="selected">Vibration / Adjustment History</a>
				<a class="bubble-tab" routerLink="track-history" routerLinkActive="selected">Track History</a>
				@if (api.user?.role === 'admin' || api.user?.role === 'master') {
				<a class="bubble-tab" routerLink="vibe-coefficients" routerLinkActive="selected">Vibe Coefficients</a>
				}
				@if (api.user?.role === 'admin' || api.user?.role === 'master') {
				<a class="bubble-tab" routerLink="track-coefficients" routerLinkActive="selected">Track Coefficients</a>
				}
			</div>
			<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
		</div>
		}
	</div>
	}
</div>